import { render, staticRenderFns } from "./eventPhase.vue?vue&type=template&id=3237edfb&scoped=true"
import script from "./eventPhase.vue?vue&type=script&lang=js"
export * from "./eventPhase.vue?vue&type=script&lang=js"
import style0 from "./eventPhase.vue?vue&type=style&index=0&id=3237edfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3237edfb",
  null
  
)

export default component.exports